import { useContext } from 'react';
import { RankingsChartsDataContext } from '../contexts/RankingsChartsDataContext';

export const useRankingsChartsDataContext = () => {
    return useContext(RankingsChartsDataContext);
};
